import React, { useState, useEffect, useMemo, useCallback } from "react";
import {
  Button,
  DatePicker,
  Popconfirm,
  Popover,
  Select,
  Space,
  Switch,
  TimePicker,
} from "antd";
import images from "../../themes/appImage";
import { Table, Modal } from "antd";
import appconstant from "../../themes/appconstant";
import { useDispatch, useSelector } from "react-redux";
import {
  createNewPushNotificationLoad,
  editPushNotificationLoad,
  deletePushNotificationLoad,
  notificationListLoad,
} from "../../redux/slices/notification.slice";
import { debounce } from "../../utils/global-func";
import moment from "moment";
import { useFormik } from "formik";
import * as Yup from "yup";
import { emptySpaceInputHandler } from "../../utils";

const combineDateTimeToUTC = (dateString, timeString) => {
  const dateTimeString = `${dateString}T${timeString}Z`;
  const dateTime = new Date(dateTimeString);
  if (isNaN(dateTime.getTime())) {
    throw new Error("Invalid date or time format");
  }
  return dateTime.toISOString();
};

const combineDateTimeToUTCS = (dateString, timeString) => {
  let date = dateString;
  let time = timeString;

  // Handle date format
  if (!date.includes("T")) {
    date += "T00:00:00.000Z"; // Simplified date without time, assuming midnight UTC
  }

  // Handle time format
  if (time.includes("T")) {
    time = time.substring(time.indexOf("T"));
  } else {
    time = `T${time}.000Z`;
  }

  const dateTimeString = `${date.substring(0, 10)}${time}`;
  const dateTime = new Date(dateTimeString);

  if (isNaN(dateTime.getTime())) {
    throw new Error("Invalid date or time format");
  }

  return dateTime.toISOString();
};

function extractTimeFromUTC(utcTimeString) {
  const utcTime = moment.utc(utcTimeString);

  if (!utcTime.isValid()) {
    throw new Error("Invalid UTC time string");
  }

  const timeString = utcTime.format("HH:mm:ss");

  return timeString;
}

const numberOfRowOptionList = [
  { value: "one", label: 10 },
  { value: "two", label: 20 },
  { value: "three", label: 25 },
];

let LIST_LIMIT = 10;
let OFFSET = 0;
let currentSortValue = -1;
let sort = "createdAt";

const userListPayload = {
  offset: 0,
  limit: 10,
  search: "",
  sort: sort,
  order: currentSortValue,
};
let isEditModal = false;
let isEditItemId = null;
let isTimeEdit = null;

const Notifications = () => {
  const dispatch = useDispatch();

  const { notificationListData, pushNotificationPushed } = useSelector(
    (state) => state.notificationReducer
  );
  const [search, setSearch] = useState("");
  const [modal1Open, setModal1Open] = useState(false);
  const [modal20Open, setModal20Open] = useState(false);
  const [popoverVisible, setPopoverVisible] = useState({});

  useEffect(() => {
    if (pushNotificationPushed) {
      const data = {
        offset: OFFSET,
        limit: LIST_LIMIT,
        search: search,
        sort: sort,
        order: currentSortValue,
      };
      isEditItemId = null;
      isTimeEdit = null;
      dispatch(notificationListLoad(data));
      setModal1Open(false);
      const newValues = {
        title: "",
        description: "",
        date: "",
        time: "",
        sendNow: false,
      };
      const newTouched = {
        title: false,
        description: false,
        date: false,
        time: false,
        sendNow: false,
      };
      formik.setValues(newValues);
      formik.setTouched(newTouched);
    }
  }, [pushNotificationPushed]);

  useEffect(() => {
    dispatch(notificationListLoad(userListPayload));
  }, []);

  const columns = [
    {
      title: "ID",
      dataIndex: "srno",
      key: "srno",
      sorter: false,
      render: (value, item, index) => index + 1,
    },
    {
      title: "Title  ",
      dataIndex: "title",
      key: "title",
      sorter: false,
      sortDirections: ["ascend", "descend"],
      title: () => {
        return (
          <div onClick={() => sortHandler("title")} className="sort-icons">
            <span>Title</span> <img src={images.arrowLeft} alt="" />
          </div>
        );
      },
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      sorter: false,
      render: (value, item, index) => (
        <div className="organization-image-sec">
          <p>{item.description}</p>
        </div>
      ),
    },
    {
      title: "Scheduled on",
      dataIndex: "scheduled",
      key: "scheduled",
      sorter: false,
      render: (value, item, index) => (
        <div className="organization-image-sec">
          <p>{moment(item.date).format("MMMM D, YYYY")}</p>
        </div>
      ),
    },
    {
      title: "Action",
      dataIndex: "Posted",
      key: "Posted",
      render: (value, item, index) => {
        const contentId = `content-${item._id}`;
        const isVisible = popoverVisible[item._id] || false;
        return (
          <div id={contentId}>
            {/* <Popover
          content={
            <div className="flex flex-col items-start">
              <Button
                type="text"
                onClick={() => {
                  formik.setValues({
                    title: item.title,
                    description: item.description,
                  });
                  setModal20Open(true);
                }}
              >
                View
              </Button>
              <Button
                type="text"
                onClick={() => {
                  isEditModal = true
                  isEditItemId = item._id
                  setModal1Open(true)
                  formik.setFieldValue('title', item.title);
                  formik.setFieldValue('description', item.description);
                  formik.setFieldValue('date', item.date);
                  formik.setFieldValue('time', item.date);
                  formik.setTouched({
                    title: false,
                    description: false,
                    date: false,
                    time: false,
                  });
                 
                }}
              >
                Edit
              </Button>
              <Popconfirm
                title="Are you sure you want to delete this item?"
                onConfirm={() => {


                  dispatch(deletePushNotificationLoad({ id: item._id }));
                  setPopoverVisible({ ...popoverVisible, [item._id]: false });
                  
                  }}
                okText="Yes"
                cancelText="No"
              >
                <Button type="text">Delete</Button>
              </Popconfirm>
            </div>
          }
          trigger="click"
          open = {isVisible}
      
        >
          <div className="action-dots-iocn">
            <span>
              <img src={images.horizontalDots} />
            </span>
          </div>
        </Popover> */}
            <Popover
              content={
                <div className="flex flex-col items-start">
                  <Button
                    type="text"
                    onClick={() => {
                      formik.setValues({
                        title: item.title,
                        description: item.description,
                      });
                      setModal20Open(true);
                      setPopoverVisible((prevState) => ({
                        ...prevState,
                        [item._id]: false,
                      }));
                    }}
                  >
                    View
                  </Button>
                  <Button
                    type="text"
                    onClick={() => {
                      setPopoverVisible((prevState) => ({
                        ...prevState,
                        [item._id]: false,
                      }));
                      isEditModal = true;
                      isEditItemId = item._id;

                      setModal1Open(true);
                      formik.setFieldValue("title", item.title);
                      formik.setFieldValue("description", item.description);
                      formik.setFieldValue("date", item.date);
                      formik.setFieldValue(
                        "time",
                        extractTimeFromUTC(item.date)
                      );
                      formik.setTouched({
                        title: false,
                        description: false,
                        date: false,
                        time: false,
                      });
                    }}
                  >
                    Edit
                  </Button>
                  <Popconfirm
                    title="Are you sure you want to delete this item?"
                    onConfirm={() => {
                      dispatch(deletePushNotificationLoad({ id: item._id }));
                      setPopoverVisible((prevState) => ({
                        ...prevState,
                        [item._id]: false,
                      }));
                    }}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Button type="text">Delete</Button>
                  </Popconfirm>
                </div>
              }
              trigger="click"
              open={isVisible}
              onClick={() =>
                setPopoverVisible((prevState) => ({
                  ...prevState,
                  [item._id]: !isVisible,
                }))
              }
            >
              <div className="action-dots-iocn">
                <span>
                  <img src={images.horizontalDots} />
                </span>
              </div>
            </Popover>
          </div>
        );
      },
    },
  ];

  // F O R M I K  F O R  -- A D D  N E W  O R G A N I Z A T I O N  M O D AL
  const validationSchema = Yup.object({
    title: Yup.string().required("Please enter title"),
    description: Yup.string()
      .required("Message Description is required")
      .min(6, "Message Description must be at least 6 characters"),
    date: Yup.string().required("Date is required"),
    time: Yup.string().required("Time is required"),
    sendNow: Yup.boolean().default(false),
  });

  const formik = useFormik({
    initialValues: {
      title: "",
      description: "",
      date: "",
      time: "",
      sendNow: false,
    },
    validationSchema,
    onSubmit: (values) => {
      console.log(values);
      const date = isEditItemId
        ? combineDateTimeToUTCS(values.date, values.time)
        : combineDateTimeToUTC(values.date, values.time);
      console.log(
        values.date,
        values.time,
        "--------------",
        isEditItemId,
        date,
        "DOT"
      );
      const payload = {
        scheduleId: isEditItemId && isEditItemId.toString(),
        title: values.title,
        description: values.description,
        date,
        sendNow: values.sendNow,
      };
      isEditItemId
        ? dispatch(editPushNotificationLoad(payload))
        : dispatch(createNewPushNotificationLoad(payload));
    },
  });

  const handleSendNowChange = (checked) => {
    if (checked) {
      const now = moment();
      formik.setFieldValue("date", now.format("YYYY-MM-DD"));
      formik.setFieldValue("time", now.format("HH:mm:ss"));
    }
    formik.setFieldValue("sendNow", checked);
  };

  // P A G I N A T I O N
  const START = useMemo(() => OFFSET + 1, [notificationListData.list]);
  const TOTAL_LIST_ITEMS = useMemo(
    () => notificationListData.pagination?.totalCount,
    [notificationListData.list]
  );

  const END = useMemo(
    () => Math.min(OFFSET + LIST_LIMIT, TOTAL_LIST_ITEMS),
    [notificationListData.list]
  );

  const paginationHandler = useCallback(
    (type) => {
      if (type === "pre") {
        OFFSET = OFFSET - LIST_LIMIT;
        const data = {
          offset: OFFSET,
          limit: LIST_LIMIT,
          search: search,
          sort: sort,
          order: currentSortValue,
        };
        dispatch(notificationListLoad(data));
      } else {
        OFFSET = OFFSET + LIST_LIMIT;
        const data = {
          offset: OFFSET,
          limit: LIST_LIMIT,
          search: search,
          sort: "createdAt",
          order: -1,
        };
        dispatch(notificationListLoad(data));
      }
    },
    [notificationListData.list]
  );

  const numberOfRowHandler = useCallback(
    (dateString, dataObj) => {
      LIST_LIMIT = dataObj.label;
      OFFSET = 0;
      const data = {
        offset: OFFSET,
        limit: LIST_LIMIT,
        search: search,
        sort: sort,
        order: currentSortValue,
      };
      dispatch(notificationListLoad(data));
    },
    [notificationListData.list]
  );

  const searchHandler = useCallback(
    (e) => {
      if (emptySpaceInputHandler(e) || e.target.value.length == "") {
        LIST_LIMIT = 10;
        OFFSET = 0;
        setSearch(emptySpaceInputHandler(e));
        const data = {
          offset: 0,
          limit: 10,
          search: emptySpaceInputHandler(e).trim(),
          order: -1,
        };
        debounce(() => dispatch(notificationListLoad(data)));
      }
    },
    [notificationListData.list]
  );

  const sortHandler = useCallback(
    (sort) => {
      currentSortValue = currentSortValue == -1 ? 1 : -1;
      const data = {
        offset: OFFSET,
        limit: LIST_LIMIT,
        search: search,
        sort: sort,
        order: currentSortValue,
      };
      dispatch(notificationListLoad(data));
    },
    [notificationListData.list]
  );

  return (
    <div>
      <div className="site-layout-background" style={{ minHeight: 360 }}>
        <div className="top-header-organi-zations">
          <div className="organi-zations-heading-text">
            <h1>Push Notifications</h1>
            <p>
              {/* Sed consectetur imperdiet facilisiulla malesua daeddiet
              facilisiulla */}
            </p>
          </div>
          <div className="add-new-button user-page-btn">
            <button
              onClick={() => {
                isEditModal = false;
                isEditItemId = null;
                const newTouched = {
                  title: false,
                  description: false,
                  date: false,
                  time: false,
                  sendNow: false,
                };
                formik.setTouched(newTouched);
                setModal1Open(true);
              }}
            >
              Add New
            </button>
          </div>
        </div>

        <div className="content-e">
          <div className="bg-gradient-primary system-line">
            <input
              type="text"
              value={search}
              onChange={searchHandler}
              className="iocn-search search-bar"
              placeholder="Search Encouragement Groups"
            />
          </div>
          <Table
            dataSource={notificationListData.list}
            columns={columns}
            showSorterTooltip={false}
            pagination={{
              current: 0,
              pageSize: 0,
              total: TOTAL_LIST_ITEMS,
            }}
          />

          {TOTAL_LIST_ITEMS > 10 && (
            <div className="footer-section">
              <div className="foot-main-div">
                <div className="rows">
                  <div className="row-per-page">
                    <p>Rows per page</p>
                  </div>

                  <div className="top-checkbox fot-select">
                    <Select
                      defaultValue={LIST_LIMIT}
                      onChange={numberOfRowHandler}
                      options={numberOfRowOptionList}
                    />
                  </div>
                </div>

                <div className="page-count">
                  <p>{`${START}-${END} of ${TOTAL_LIST_ITEMS}`}</p>
                </div>

                <div className="back-and-next">
                  <span
                    onClick={() => OFFSET !== 0 && paginationHandler("pre")}
                  >
                    <img src={images.per} alt="back" />
                  </span>
                  <span
                    onClick={() =>
                      OFFSET + LIST_LIMIT < TOTAL_LIST_ITEMS &&
                      paginationHandler("next")
                    }
                  >
                    <img src={images.new} alt="back" />
                  </span>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* create inner circle */}
      <Modal
        title=""
        className="modal-update"
        destroyOnClose={true}
        centered
        open={modal1Open}
        closable={true}
        onCancel={() => {
          isEditModal = false;
          isEditItemId = null;
          isTimeEdit = null;
          formik.setFieldValue("title", "");
          formik.setFieldValue("description", "");
          formik.setFieldValue("date", "");
          formik.setFieldValue("time", "");
          setModal1Open(false);
        }}
        footer={false}
        width={600}
      >
        <div className="add-user-popup">
          <div className="modal-add-user">
            <h1>
              {isEditModal
                ? "Edit push notification"
                : "Create new push notification"}{" "}
            </h1>
          </div>
          <form onSubmit={formik.handleSubmit}>
            <div className="description-inner-circle">
              <div className="wrapper_line">
                <div className="form-group">
                  <div className="enter-title-num">
                    <label>{appconstant.title}</label>
                    {/* <p>0/10</p> */}
                  </div>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Enter Activity Title"
                    name="title"
                    value={formik.values.title}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.title && formik.errors.title ? (
                    <div className="text-red-500 text-xs mt-1 font-normal">
                      {formik.errors.title}
                    </div>
                  ) : null}
                </div>

                <div className="form-group mt-6">
                  <div className="textarea-label">
                    <label>{appconstant.messageDescription}</label>
                    {/* <p>0/500</p> */}
                  </div>
                  <textarea
                    rows="5"
                    cols="50"
                    className="form-control-textarea"
                    type="textarea"
                    placeholder="Enter Description "
                    name="description"
                    value={formik.values.description}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.description && formik.errors.description ? (
                    <div className="text-red-500 text-xs mt-1 font-normal">
                      {formik.errors.description}
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
            <div className="add-sugg-activity" style={{ marginTop: "66px" }}>
              <div className="space-timing flex">
                <div
                  className="date-and-time"
                  style={{ display: formik.values.sendNow ? "none" : "flex" }}
                >
                  <div className="select-date form-group">
                    <div className="textarea-label label-text">
                      <label>{appconstant.selectDate}</label>
                    </div>
                    <Space direction="vertical">
                      <DatePicker
                        placeholder="Date"
                        disabled={formik.values.sendNow}
                        value={formik.values.date && moment(formik.values.date)}
                        onChange={(date, dateString) => {
                          formik.setFieldValue("date", dateString);
                        }}
                      />
                      {formik.touched.date && formik.errors.date ? (
                        <div className="text-red-500 text-xs mt-1 font-normal">
                          {formik.errors.date}
                        </div>
                      ) : null}
                    </Space>
                  </div>

                  <div className="select-date form-group">
                    <div className="textarea-label label-text">
                      <label>{appconstant.selectTime}</label>
                    </div>
                    {isEditItemId && isTimeEdit == null ? (
                      <TimePicker
                        placeholder="Time"
                        disabled={formik.values.sendNow}
                        value={
                          formik.values.time
                            ? moment(formik.values.time, "HH:mm:ss")
                            : null
                        }
                        onChange={(time, timeString) => {
                          console.log(timeString);

                          formik.setFieldValue("time", timeString);
                        }}
                      />
                    ) : (
                      <TimePicker
                        placeholder="Time"
                        disabled={formik.values.sendNow}
                        onChange={(time, timeString) => {
                          formik.setFieldValue("time", timeString);
                        }}
                      />
                    )}
                    {formik.touched.time && formik.errors.time ? (
                      <div className="text-red-500 text-xs mt-1 font-normal">
                        {formik.errors.time}
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>

              {isEditItemId == null && (
                <div className="switch-btn mt-4 send-now-switch">
                  <Switch
                    checked={formik.values.sendNow}
                    onChange={handleSendNowChange}
                  />
                  <p>Send Now</p>
                </div>
              )}
            </div>
            <div className="click-to-upload">
              <div className="add-activity-button create-add-option">
                <button type="submit">Update</button>
              </div>
            </div>
          </form>
        </div>
      </Modal>

      <Modal
        title=""
        className="modal-update"
        destroyOnClose={true}
        centered
        open={modal20Open}
        closable={true}
        onCancel={() => setModal20Open(false)}
        footer={false}
        width={600}
      >
        <div className="add-user-popup">
          <div className="modal-add-user">
            <h1> push notification Detail </h1>
          </div>
          <form onSubmit={formik.handleSubmit}>
            <div className="description-inner-circle">
              <div className="wrapper_line">
                <div className="form-group">
                  <div className="enter-title-num">
                    <label>{appconstant.title}</label>
                  </div>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Enter Activity Title"
                    name="title"
                    value={formik.values.title}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    disabled={true}
                  />
                </div>

                <div className="form-group mt-6">
                  <div className="textarea-label">
                    <label>{appconstant.messageDescription}</label>
                  </div>
                  <textarea
                    rows="5"
                    cols="50"
                    className="form-control-textarea"
                    type="textarea"
                    placeholder="Enter Description "
                    name="description"
                    value={formik.values.description}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    disabled={true}
                  />
                </div>
              </div>
              <div className="mt-[100px]"></div>
            </div>
          </form>
        </div>
      </Modal>
    </div>
  );
};
export default Notifications;
